import React, { Component } from "react";
import Select from "react-select";
export default class CollectionAddToModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isCreateNewScreenOpen: false, selectedOption: null };
  }

  createNewCollection = () => {
    console.log("created");
    this.setState({ isCreateNewScreenOpen: true });
  };

  render() {
    const options = [
      {
        value: "chocolate",
        label: (
          <div>
            <img
              width="30px"
              height="30px"
              src="https://image.flaticon.com/icons/svg/2909/2909471.svg"
            />
            Private
          </div>
        )
      },
      { value: "strawberry", label: <div>Public</div> },
      { value: "vanilla", label: <div>Anyone with a link </div> }
    ];

    return (
      <div className="collection-dialog-outer">
        <div className="collection-dialog-inner">
          <div className="collection-dialog-add-container">
            <div className="collection-dialog-add-text-container">
              <div className="collection-dialog-add-text">Add to ...</div>
            </div>
            <div className="collection-dialog-add-tab-container">
              <input
                type="checkbox"
                id="vehicle1"
                name="vehicle1"
                value="Bike"
              />
              <div className="collection-dialog-add-tab-collection-name">
                Watch Later
              </div>
            </div>
            <div className="collection-dialog-add-tab-container">
              <input
                type="checkbox"
                id="vehicle1"
                name="vehicle1"
                value="Bike"
              />
              <div className="collection-dialog-add-tab-collection-name">
                Best 2020 Roadmapsa sfasfasfas fasfas fasfasfasf asfasf a
                asfsafasfas as
              </div>
            </div>
          </div>
          <div className="collection-dialog-create-container-outer">
            <div className="collection-dialog-create-container">
              {this.state.isCreateNewScreenOpen ? (
                <div className="collection-dialog-creating-container">
                  <input
                    placeholder="Enter Collection Name"
                    className="collection-dialog-name-input"
                    maxLength="100"
                  ></input>
                  <div className="collection-dialog-privacy-select">
                    <Select
                      options={options}
                      onChange={this.handleChange}
                      value={this.state.selectedOption}
                    />
                  </div>
                </div>
              ) : (
                <React.Fragment>
                  <div className="collection-dialog-create-icon-container">
                    <img
                      className="collection-dialog-create-icon"
                      src="https://image.flaticon.com/icons/svg/748/748113.svg"
                    />
                  </div>
                  <div
                    className="collection-dialog-create-text"
                    onClick={this.createNewCollection}
                  >
                    Create new Playlist
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
